<template>
  <div class="Pricing">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="pricing-details-container">
      <PricingComponent></PricingComponent>
    </div>

  </div>
</template>
<script>
import { screenSize } from "../mixins/ScreenSize.js";
import PlainSideBar from "@/components/PlainSideBar.vue";
import MobileNav from "@/components/MobileNav.vue";
import PricingComponent from "@/components/RetailSideCompo/PricingComponent.vue";

export default {
  name: "Pricing",
  mixins: [
    screenSize,
  ],
  components: {
    PlainSideBar,
    MobileNav,
    PricingComponent,
  },
  data() {
    return {
      nav_title: "Pricing Plans",
    };
  },
  beforeRouteEnter(to, from, next) {
    var currentUrl = localStorage.getItem("currentUrl")
      ? localStorage.getItem("currentUrl")
      : window.location.href;

    var websiteUserType = localStorage.getItem("websiteUserType")
      ? JSON.parse(localStorage.getItem("websiteUserType"))
      : {};

    if ( websiteUserType.userSubType == 'brokerWithoutPlans') {
      next("/data-categorisation"); // Redirect using next
    } else {
      next(); // Continue with the navigation
    }
  },

  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.Pricing {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0;
}

.Pricing .pricing-details-container {
  box-sizing: border-box;
}

.Pricing .pricing-details-section {
  padding: 20px 20px 20px 20px;
}

.Pricing .non-paid-pricing-card {
  background-color: #eff5fe;
  box-sizing: border-box;
  min-height: 700px;
  border-radius: 20px;
  padding: 20px 20px;
}

.Pricing .pro-pricing-card {
  background-color: #2d2e8d;
  box-sizing: border-box;
  min-height: 700px;
  border-radius: 20px;
  padding: 20px 20px;
}

@media screen and (max-width: 1265px) and (min-width: 1140px) {

  .non-paid-pricing-card,
  .pro-pricing-card {
    min-height: 740px !important;
  }
}

.Pricing .price-tag {
  font-size: 1rem;
  font-weight: 600;
}

.header {
  display: flex;
  justify-content: space-between;
  height: 40px;
}

.lite-card .border-color:after,
.premium-card .border-color:after {
  position: absolute;
  bottom: -20px;
  left: 13px;
  width: 22px;
  height: 3px;
  margin-bottom: 25px;
  content: "";
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: $secondary-theme-color;
}

.pro-pricing-card .border-color:after {
  position: absolute;
  bottom: -20px;
  left: 13px;
  width: 22px;
  height: 3px;
  margin-bottom: 25px;
  content: "";
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: #fff;
}

.Pricing .feature-title {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  line-height: 1.5;
}

.Pricing .btn-position {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  text-align: center;

  .select-plan {
    background-color: transparent;
    border-color: $primary-theme-color;
    color: $primary-theme-color;
    font-size: 13px;
    height: 30px;
    line-height: 0.8;
    width: 250px;
  }

  .background-transparent {
    background-color: transparent;
  }

  .background-gradient {
    background-image: -webkit-gradient(linear,
        right top,
        left top,
        from(#dc6250),
        to(#eb5151));
    background-image: linear-gradient(to left, #dc6250, #eb5151);
    color: #fff;
    border: none;
  }
}

.Pricing .payment-success-dialog {
  .modal-content {
    .dailog-bg {
      background: $secondary-theme-color;
      // background: url('../assets/images/dashboard/dialog-background.png');
      background-repeat: no-repeat;
      background-position: center center;
      height: 120px;
      padding: 20px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    .dialog-decp {
      display: block !important;
    }

    .plan-details-section {
      .title {
        font-size: 0.9rem;
        color: #fff;
        font-weight: 600;
      }

      .sub-title {
        font-weight: 600;
        font-size: 0.7rem;
        color: #fff;
      }

      .first-col {
        text-align: left;
      }

      .second-col {
        text-align: right;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .modal-content .dailog-bg {
      height: 165px !important;
    }
  }
}

.Pricing .footer-section {
  // width: calc(100% - 260px);
  // margin-left: 260px;
}

@media screen and (max-width: 1283px) {
  .Pricing {
    padding: 50px 0 70px;
  }

  .Pricing .pricing-details-container,
  .Pricing .footer-section {
    width: 100%;
    margin-left: 0;
  }

  .Pricing .account-details-section {
    padding: 20px 10px 0 10px;
  }

  .Pricing .sideBarSection {
    display: none;
  }
}
</style>
<style lang="scss">
.Pricing {
  .unsubscribe-plan-notification-dialog {
    .el-dialog {
      border-radius: 10px;
    }
  }

  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }

  .pricing-dropdwn .el-input__inner {
    height: 25px !important;
    line-height: 25px !important;
  }

  @media screen and (max-width: 900px) {
    .unsubscribe-plan-notification-dialog .el-dialog {
      width: 90%;
    }
  }
}
</style>
